import { useEffect } from 'react';

import { configureMerchantCartOrigin } from '../commerce/crossSiteCartStamp';

/**
 * Tell the cross-site cart stamp which cart this front room writes to.
 *
 * A front room with no cart of its own stamps the merchant's Shopify cart, which lives
 * on a sibling subdomain. The operator-set host on the Shopify channel names that cart,
 * so the stamp does not depend on a product url ever rendering.
 *
 * It runs as the concierge mounts, so it must never throw.
 */
export function useMerchantCartOrigin(channels: unknown): void {
  useEffect(() => {
    try {
      configureMerchantCartOrigin(channels);
    } catch {
      // Attribution is best-effort and must never cost the shopper the concierge.
    }
  }, [channels]);
}
